<template>
  
  <v-tooltip 
    content-class = "tooltip_container"
    bottom
    open-delay    = "500"
    color         = "#151515"
  >

    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind    = "attrs"
        v-on      = "on"
        :disabled = "disabled"
        :color    = "color"
        :large    = "large"
        @click    = "$emit('click', $event);"
      >
        <slot></slot>
      </v-btn>
    </template>

    <span>
      <span class="tooltip">{{ tooltip }}</span>
      <span v-if="hotkey"
            class="hotkey"
      >{{ hotkey }}</span>
    </span>

  </v-tooltip>

</template>

<script lang="js">

export default {

  // #region Properties

  name:  'VideoControlButton',
  props: {
    color:    String,
    disabled: Boolean,
    tooltip:  String,
    hotkey:   String,
    large:    Boolean
  }

  // #endrgion Properties

}

</script>

<style lang="scss" scoped>

.tooltip_container {
  opacity:      1 !important;
}

$hotkey_color: rgba(255, 255, 255, 0.6);

.hotkey {
  margin-left:    16px;
  color:          $hotkey_color;
  border:         1px solid $hotkey_color;
  border-radius:  4px;
  padding:        2px 6px;
}

</style>